export default {
  data: {
    loading: false,
    hasMounted: false,
  },
  mounted() {
    // loading indicator mounting
    Vue.nextTick(() => {
      this.hasMounted = true;
    });
  },
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/loading.js